<template>
    <div>
        <HeaderSection icon="fas fa-check" title="Requisitos Pre-Registro de Usuarios">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/administracion')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>
        <br>
        <span>
            <el-row :gutter="24">
                <el-col :span="24">
                    <el-select v-model="profileId"
                               v-loading="loading"
                               element-loading-text=""
                               element-loading-spinner="el-icon-loading"
                               placeholder="Selecciona un perfil" filterable
                               @change="getPermissions()">
                            <el-option
                                v-for="item in profiles"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <br>
            <span v-if="rules.length > 0">
               <el-row :gutter="24">
                    <div class="tip">
                            Seleccione los documentos requeridos para el perfil seleccionado
                    </div>
                    <el-table v-loading="loading"
                              element-loading-text="Actualizando..."
                              element-loading-spinner="el-icon-loading"
                              ref="multipleTable"
                              @selection-change="handleSelectionChange"
                              :data="rules" border stripe>
                        <el-table-column
                            type="selection"
                            width="55">
                        </el-table-column>
                        <el-table-column label="Documento" prop="name"></el-table-column>
                    </el-table>
                    <div style="margin-top: 20px">
                        <el-button @click="toggleSelection()">Limpiar selección</el-button>
                    </div>
               </el-row>
               <el-row>
                    <div align="right">
                        <el-button @click="restartForm">Cancelar</el-button>
                        <el-button type="primary" @click="submitRequirementBy()">Actualizar</el-button>
                    </div>
               </el-row>
            </span>

        </span>


    </div>
</template>

<script>
    import HeaderSection from "../../../../partials/HeaderSection";

    export default {
        components: {
            HeaderSection
        },
        data() {
            return {
                rules: [],
                profiles: [],
                profileId: null,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                multipleSelection: [],
                loading: false,
                distributionAux: []
            }
        },

        created() {
            axios.get('/api/get-profiles').then(response => {
                if (response.data.success) {
                    this.profiles = response.data.profiles.filter(up => up.id >= 4)
                }
            }).catch(error => {
                console.log('created', error);

                this.$notify({
                    type: 'error',
                    message: 'No se pudo completar la acción'
                });
            });
        },

        methods: {
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },

            restartForm() {
                this.rules = [];
                this.profileId = null;
            },
            getPermissions() {
                this.rules = [];
                this.loading = true;
                this.distributionAux = [];
                axios.get('/api/get-rules', {params: {cat_profile_id: this.profileId}}).then(response => {
                    if (response.data.success) {
                        this.rules = response.data.rules;
                        this.distributionAux = response.data.distribution

                    }else{
                        console.log('this')
                        this.$notify({
                            type: 'warning',
                            message: response.data.message
                        });
                    }
                    setTimeout(() => {
                        if (this.distributionAux && this.distributionAux.length > 0) {
                            _.forEach(this.distributionAux, (item, key) => {
                                let _filter = this.rules.filter( up => up.id == item.cat_requirement_document_id);
                                if(_filter && _filter.length > 0){
                                    this.toggleSelection(_filter);
                                }
                            })
                        }
                    },500)

                    this.loading = false;
                }).catch(error => {
                    console.log('getPermissions', error);

                    this.$notify({
                        type: 'error',
                        message: 'No se pudo completar la acción'
                    });
                });



            },

            submitRequirementBy() {

                let data = {
                    cat_profile_id: this.profileId,
                    rules: this.multipleSelection
                };
                axios.post('/api/submit-profile-rules', data).then((response) => {
                    this.$store.dispatch('loading/spinner', {}, {root: true});
                    const parsedResponse = response.data;
                    if (parsedResponse && parsedResponse.success) {
                        this.$message({
                            message: parsedResponse.message,
                            type: 'success'
                        });

                    }else{
                        this.$notify({
                            type: 'warning',
                            message: response.data.message
                        });
                    }

                })
                    .catch((err) => {
                        this.$store.dispatch('loading/spinner', {}, {root: true});
                        let msg = 'No se pudo completar la acción';
                        this.$message.error('Oops,' + msg);
                    });

            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log('asaas',this.multipleSelection)
            }
        }


    }
</script>

<style scoped>

</style>
